const e=(e,o)=>"string"==typeof e?e.toLowerCase().includes(o):!!Array.isArray(e)&&e.some(e=>"string"==typeof e&&e.toLowerCase().includes(o.toLowerCase()));export{e as validateIncludeString};
